import React from "react";
import { Link } from "react-router-dom";
import {
  ShieldExclamationIcon,
  HomeIcon,
  ArrowLeftIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../../contexts/AuthContext";

function Unauthorized() {
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <ShieldExclamationIcon className="w-24 h-24 text-red-500 mx-auto mb-4" />
          <h1 className="text-6xl font-bold text-red-600">403</h1>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Erişim Reddedildi
        </h2>

        <p className="text-lg text-gray-600 mb-8 max-w-md">
          Bu sayfaya erişim yetkiniz bulunmuyor.
          {!isAuthenticated && " Lütfen önce giriş yapın."}
          {isAuthenticated &&
            user?.role !== "admin" &&
            " Bu sayfa sadece admin kullanıcıları içindir."}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {!isAuthenticated ? (
            <>
              <Link to="/login" className="btn btn-primary btn-lg">
                Giriş Yap
              </Link>
              <Link to="/" className="btn btn-secondary btn-lg">
                <HomeIcon className="w-5 h-5 mr-2" />
                Ana Sayfa
              </Link>
            </>
          ) : (
            <>
              <Link
                to={user?.role === "admin" ? "/admin" : "/dashboard"}
                className="btn btn-primary btn-lg"
              >
                <HomeIcon className="w-5 h-5 mr-2" />
                {user?.role === "admin" ? "Admin Panel" : "Dashboard"}
              </Link>
              <button
                onClick={() => window.history.back()}
                className="btn btn-secondary btn-lg"
              >
                <ArrowLeftIcon className="w-5 h-5 mr-2" />
                Geri Git
              </button>
            </>
          )}
        </div>

        <div className="mt-12">
          <p className="text-sm text-gray-500 mb-2">
            Sorun devam ediyorsa destek ekibimizle iletişime geçin:
          </p>
          <a
            href="mailto:support@kslnk.link"
            className="text-primary-600 hover:text-primary-700 font-medium"
          >
            support@kslnk.link
          </a>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
